import React, { useContext, useEffect, useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { CreateReferral } from 'components/marketing/components/createReferrals';
import { ViewReferrals } from 'components/marketing/components/viewReferrals';
import { UserContext } from 'contexts/UserContext';
import { TabPanel } from 'shared';

function ReferralProgram() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    const { roles } = useContext(UserContext);
    const canEditReferrals = roles?.some((role) => role.name.endsWith('UPDATE REFERRALS'));

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewReferrals_Tab" label="View Referrals" value="0" />
                {canEditReferrals && <Tab id="CreateReferral_Tab" label="Create Referrals" value="1" />}
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewReferrals />
            </TabPanel>
            {canEditReferrals && (
                <TabPanel selectedTab={selectedTab} index="1">
                    <CreateReferral />
                </TabPanel>
            )}
        </Paper>
    );
}

export { ReferralProgram };
